<template>
  <ProductionInventoryStock kind="finished" />
</template>
<script setup>
import ProductionInventoryStock from '@/components/module/production/ProductionInventoryStock.vue';
</script>
